export default [

     {
          path: '/standard-level',
          name: 'StandardLevel',
          component: () => import("@/views/Page/StandardLevel/StandardLevel.vue"),
           meta: {
               title: '#Default# | StandardLevel',
          },
     }
];